<template>
  <div class="animated fadeIn">
    <b-row class="justify-content-center">
      <b-col lg="10" xl="8">
        <b-card >
          <div slot="header">PnL per Program - Step 2 Import Non Airtime Revenue from GL </div>
            <b-input-group>
              <b-input-group-prepend>
                <span class="pt-1 mr-2">Periode Pnl per Program </span>
              </b-input-group-prepend>
              <vue-monthly-picker
                style="width:350px;"
                v-model="model.periode"
                dateFormat="MMMM YYYY"
                :monthLabels="monthLabels" :state="!$v.model.periode.$error"
              ></vue-monthly-picker>
            </b-input-group>
                <b-table
                    class="mb-0"
                    ref="tblAdvLines"
                    outlined striped hover small
                    style="font-size:smaller;" 
                    :items="advLines.items"
                    :fields="advLines.fields"
                    >
                        <template v-slot:cell(index)="data">
                            {{data.index + 1}}
                        </template>
                        <template v-slot:cell(Dim2Criteria)="data">
                          <span v-if="(data.item.Dim2Criteria==1)">Hanya yg ditemukan dlm pola acara</span>
                          <span v-if="(data.item.Dim2Criteria==0)">Hanya yg tidak ditemukan dlm pola acara</span>
                          <span v-if="(data.item.Dim2Criteria==2)">Semua Transaksi</span>
                        </template>

                        <template v-slot:cell(action)="data">
                            <div class="text-center">
                            <a href="javascript:void(0)" @click="editAdvLines(data.item,data.toggleDetails)">
                                <i class="fa fa-pencil"></i>
                            </a>
                            |
                            <a href="javascript:void(0)" class="text-danger" @click="delAdvLines(data.index)">
                                <i class="fa fa-trash"></i>
                            </a>
                            </div>
                        </template>
                    <template v-slot:row-details="row">
                    <b-card class="row-details-form">
                        <b-row>
                        <b-col xl="8">
                            <b-input-group >
                                <b-input-group-prepend><label>Pnl Column</label></b-input-group-prepend>
                                <b-form-select v-model="advLinesObj.layout" :plain="true" :options="pnlKoloms" :state="!$v.advLinesObj.pnlKolom.$error"></b-form-select>
                            </b-input-group>
                            <b-input-group>
                                <b-input-group-prepend><label>GL Account No.</label></b-input-group-prepend>
                                <b-form-input readonly v-model="advLinesObj.glAccount" @keyup.13.native="lkuCoaShow=true" :state="!$v.advLinesObj.kodeacc.$error"></b-form-input>
                                <b-input-group-append>
                                <b-btn text="Button" @click="lkuCoaShow=true" id="glAccount">
                                    <i class="fa fa-search"></i>
                                </b-btn>
                                </b-input-group-append>
                            </b-input-group>
                        </b-col>
                        </b-row>
                        <b-input-group>
                            <b-input-group-prepend><label>Kode Program</label></b-input-group-prepend>
                            <b-form-radio-group  v-model="advLinesObj.Dim2Criteria" name="radioIndividu" class="ml-1 mt-1" :state="!$v.advLinesObj.Dim2Criteria.$error">
                                <b-form-radio :value="1">Hanya yg ditemukan dlm pola acara</b-form-radio>
                                <b-form-radio :value="0">Hanya yg tidak ditemukan</b-form-radio>
                                <b-form-radio :value="2">Semua Transaksi</b-form-radio>
                            </b-form-radio-group>
                        </b-input-group>
                        <b-row class="justify-content-center mt-1">
                            <b-button class="btn btn-info mr-1" @click="saveAdvLines()">Update</b-button>
                            <b-button class="btn btn-warning ml-1" @click="row.toggleDetails">Cancel</b-button>
                        </b-row>
                    </b-card>
                    </template>                        
                </b-table>
                <b-button size="sm" class="ml-3" @click="addAdvLines" >Add Account</b-button>                          
            </b-card>
            <div slot="footer" style="text-align:center;">
              <button class="btn btn-primary mr-1" @click="upload()">
                <i class="fa fa-play"></i> Process
              </button>
             <b-button variant="secondary" class="mr-1" @click="close()" > <i class="fa fa-close"></i> Close Form</b-button>
            </div>
          </b-card>
      </b-col>
    </b-row>
        <b-modal v-model="lkuCoaShow" size="lg" :hide-footer="true" title="List of GL Account" :centered="true">
            <lku-coa @click="onSelectLkuCoa" :tahun="tahun" :key="tahun"></lku-coa>
        </b-modal>        

  </div>
</template>

<style lang="scss">
    .input-group {
        padding-bottom:2px;
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 130px;
            }
        }
    }
    .form-group {
        margin-bottom:2px;
        .input-group {
            padding-bottom:0;
        }
    }
    .row-details-form {
        label {
        text-align: right !important;
        }
        legend {
        text-align: right !important;;
        }
    }
</style>


<script>
import VueMonthlyPicker from "vue-monthly-picker";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import moment from "moment";
import crud from "../../apis/crud";
import programtv from "../../apis/programtvpnl";
import lkuCoa from "../lookup/lkuCoa";
import toastr from "mini-toastr";
import { validationMixin } from "vuelidate";
import { required} from "vuelidate/lib/validators";
import dropdown from "../../data/dropdown";
toastr.init();

export default {
  components: {VueMonthlyPicker, Loading,lkuCoa},
  mixins: [validationMixin],
  validations: {
        model: {
            periode: { required },
        },
        advLinesObj: {
            pnlKolom: { required },
            kodeacc : { required },
            Dim2Criteria: { required },
        },        
  }, 
  data() {
    return {
      isLoading:false,
      monthLabels: dropdown.monthLabels,
      model:{periode:''},
      advLines: {
          items: [{pnlKolom:'Revenue Non Iklan Materi Program', kodeacc:'43101', glAccount:'43101 | Pendapatan Non Iklan-Profil Niaga, infomercial, Inhouse Production', Dim2Criteria:1},
                  {pnlKolom:'Revenue Non Iklan lain-lain', kodeacc:'43101', glAccount:'43101 | Pendapatan Non Iklan-Profil Niaga, infomercial, Inhouse Production', Dim2Criteria:0},
                  {pnlKolom:'Revenue Non Iklan Rekaman Program', kodeacc:'43102', glAccount:'43102 | Pendapatan Non Iklan-Rekaman Program', Dim2Criteria:1},
                  {pnlKolom:'Revenue Non Iklan lain-lain', kodeacc:'43102',glAccount:'43102 | Pendapatan Non Iklan-Rekaman Program', Dim2Criteria:0}            
          ],
          selected:{},
          fields: [
              {key: 'index', label: 'No.' ,thStyle: "width:40px"},
              {
                  key: "pnlKolom",
                  label: "Pnl Program Coloum"
              },
              {
                  key: "glAccount",
                  label: "GL Account"
              },
              {
                  key: "Dim2Criteria",
                  label: "Kode Program (dimmension column)",
              },
              {
                  key: "action",
                  label: "Action",
                  thStyle: "width:100px",
                  thClass: "text-center",
              },
          ],
          page: 1,
          limit: 5,
          total: 0,
      },
      advLinesObj:{kodeacc:'', Dim2Criteria:1},
      pnlKoloms:['Revenue Non Iklan Materi Program', 'Revenue Non Iklan lain-lain'],  
      tahun:(this.$store.state.user.tglaktif || '').substring(0,4),
      lkuCoaShow:false
    };
  },
  computed: {
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
    invalidAdvLines() {
      this.$v.advLinesObj.$touch();
      return this.$v.advLinesObj.$invalid;
    },
    Dim2Criteria() {
      return this.advLinesObj.Dim2Criteria;
    }
  },
  watch:{
    Dim2Criteria: function(newval) {

        this.tblData.DimVal="";
        this.tblData.DimValInfo="";
        this.tblData.DimColInfo=this.dimension.find(d => d.value === newval).text;
    },
  },
  created: async function(){
      const [uploadConfig] = await crud.list({tablename:'upload-polacara'});
        for (var key in uploadConfig) {
            this.model[key] = uploadConfig[key];
        }

      const tglaktif = moment(new Date(), 'YYYY-MM-DD');
      // this.model.tgl1 =  tglaktif.startOf('month').format('YYYY-MM-DD');
      this.model.periode =  tglaktif.endOf('month').format('YYYY-MM-DD');

  },  
  methods: {
    onSelectLkuCoa(_selected) {
        this.advLinesObj.glAccount = _selected.kodeacc.trim() + ' | ' + _selected.namaacc.trim();
        this.advLinesObj.kodeacc = _selected.kodeacc;
        this.advLinesObj.namaacc = _selected.namaacc;
        this.lkuCoaShow=false;
    },
    closeAdvLines: function(){
        const opened= this.advLines.items.find( r=> r._showDetails==true);
        if (opened) opened._showDetails=false;
    },
    addAdvLines : function () {
        this.closeAdvLines();
        const obj={_showDetails:true,kodeacc:'', Dim2Criteria:''};
        this.advLines.selected = obj;
        this.advLinesObj.Dim2Criteria=1;
        this.advLinesObj.kodeacc = '';
        this.advLines.items.push(obj);
        this.advLines.total=this.advLines.items.length;
    },
    editAdvLines : function (obj,callback) {
        this.closeAdvLines();
        this.advLines.selected = obj;
        this.advLinesObj.Dim2Criteria=obj.Dim2Criteria;
        this.advLinesObj.kodeacc = obj.kodeacc;
        this.advLinesObj.glAccount = obj.glAccount;
        callback();
    },
    delAdvLines: function (index) {
        if (index > -1) {
        this.advLines.items.splice(index, 1);
        }
        this.advLines.total=this.advLines.items.length;
    },
    saveAdvLines: async function (callback) {
        if (this.invalidAdvLines) {
            console.log('validation : ', this.$v.advLinesObj);
            console.log('model obj : ',this.advLinesObj);
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
       } else {
            try {
                for (var key in this.advLinesObj) {
                    this.advLines.selected[key] = this.advLinesObj[key];
                }
                this.advLines.total=this.advLines.items.length;
                this.advLines.selected._showDetails=false;
                if (callback) callback();
            } catch (error) {
                console.log('error : ', error);
                if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }
            }
        }
    },
    upload: async function() {
      if (this.invalidModel) {
            console.log('validation : ', this.$v.model);
            console.log('model obj : ',this.model);
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
        } else if (this.fileXlsx) {
            this.isLoading=true;
            try {
                const response = await programtv.upload(this.fileXlsx,this.model);
                this.isLoading=false;   
                console.log(response); 
            } catch (error) {
                this.isLoading=false;
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else {
                  if (error.message) {
                      toastr.error(error.message,'ERROR MESSAGE',10000);
                  } else {
                      toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                  }
                }
            }
        } else {
          toastr.warn('Please select one File XLSX that want to Upload ');
        }
    },
    closeFrm(){
      this.showForm=false;
      this.showList=true;
    },    
    close(){
      router.push({ name: "budget.pnlprogprocess"});
    //   console.log('this.$store.state.prevRoute.name : ',this.$store.state.prevRoute.name);
      // if ((this.$store.state.prevRoute.name) && (this.$store.state.prevRoute.name !== 'procurement.tendering')) {
      //   router.push({name:this.$store.state.prevRoute.name});
      // } else {
      //   // router.push({name:'payable.apinv'});
      //     router.push("home");
      // }
    }

  }
};
</script>
